import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import { Location } from "@angular/common";
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { PhameeService } from 'src/app/services/phamee.service';
import { UtilService } from 'src/app/services/utils.service';

declare const $:any;

@Component({
  selector: 'smart-manage-farm-plot-create',
  templateUrl: './manage-farm-plot-create.component.html',
  styleUrls: ['./manage-farm-plot-create.component.scss','../../platform-color/platform-color.css']
})
export class ManageFarmPlotCreateComponent implements OnInit {
  form: FormGroup;
  submitted: boolean = false;

  image = null;
  selectFile = null;

  polygons: any[] = [];

  AllPlot = [];
  allPolygon: any[] = [];
  zoom = 18;
  // initial center position for the map
  lat: number = 13.764913;
  lng: number = 100.538283;
  loadMap: boolean = false;
  loadPolygon: boolean = false;
  polygon: any;

  farmDetail = null;

  id: string;
  name: string;
  zone_id: string;
  plot_id: string;
  totalPlot: number;

  tab: number = 1;
  successModal: string = '#successModal';
  errorModal: string = '#errorModal';
  warningModal: string = '#warningModal';

  errorMessage: string = 'กรุณาลองใหม่อีกครั้ง';
  
  managerOptions = {
    drawingControl: true,
    drawingControlOptions: {
      drawingModes: ['polygon']
    },
    polygonOptions: {
      draggable: true,
      editable: true,
      fillColor: "black",
      strokeColor: "black",
      strokeWeight: "2"
    },
    drawingMode: "polygon",
  };
  minEnddate: boolean = false;
  sizeFileOver: boolean = false;
  typeFileOver: boolean = false;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private formBuilder: FormBuilder,
    private UtilService: UtilService,
    private farmService: FarmService,
    private phameeService: PhameeService,
    private sanitizer: DomSanitizer,

    private cd: ChangeDetectorRef
  ) { 
    this.id = this.route.snapshot.paramMap.get("id");
    this.name = this.route.snapshot.paramMap.get("name");
    this.totalPlot = this.UtilService.totalplot;
  }

  ngOnInit(): void {
    this.createForm();
    this.getFarmByname(this.name);
  }

  createForm(){
    this.form = this.formBuilder.group({
      color: ["", [Validators.required]],
      name: ["", [Validators.required, Validators.pattern(/[\S]/g)]],
      area_size: ["", [Validators.required]],
      type: ["", [Validators.required]],
      start_date: ["", [Validators.required]],
      end_date: ["", [Validators.required]],
      desc: [""],
      video: ["https://samplelib.com/lib/preview/mp4/sample-5s.mp4", [Validators.required]],
      camera_flag: [false],
      camera_id: [""],
    })
    this.valueChange();
  }


  valueChange(){
    this.form.controls.camera_flag.valueChanges.subscribe(
      (value) => {

        if(value){
          this.form.get('camera_id').setValidators([Validators.required]);
        }else{
          this.form.get('camera_id').setValue("");
          this.form.get('camera_id').setValidators(null);
        }
        this.form.get('camera_id').updateValueAndValidity();
      }
    );
  }

  get f() {
    return this.form.controls;
  }

  startDateChanged(event){
    this.minEnddate = event;

    this.form.get('end_date').setValue("");
  }

  getFarmByname(name){
    if(name){
      this.farmService.getFarmByName(name).subscribe(success => {
        if (success.code == 200) {
          this.farmDetail = success.data[0];

          this.getPlots(this.id);

          this.lat = this.farmDetail.coordinates['center'].lat;
          this.lng = this.farmDetail.coordinates['center'].lon;
          this.zoom = this.farmDetail.coordinates['center'].zoom_lv;

          this.loadMap = true;

          setTimeout(() => {
            this.reset();
          }, 1000);
        }
      });
    }
  }

  getPlots(farmId) {
    this.phameeService.getPlotDashboard(farmId)
      .subscribe(success => {
        if (success.code == 200) {
          this.AllPlot = success.data.plot;
        }
      });
    }  

  zoomChange(zoom_lv){
    this.zoom = zoom_lv;
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      draggable: true,
      editable: true,
      visible: true,
      controlSize: 30,
    });

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('delete'));

    for (let i = 0; i < this.AllPlot.length; i++) {
      let polygons = [];
      const element = this.AllPlot[i];
      if(element.coordinates.map_polygon.length > 0){
        for (let j = 0; j < element.coordinates.map_polygon.length; j++) {
          const elementPolygon = element.coordinates.map_polygon[j];

          polygons.push(
            new google.maps.LatLng(elementPolygon.lat, elementPolygon.lon),
          )
        }
      }
        
      this.allPolygon.push(
        { polygons: polygons, color: element.zone.color || 'red' }
      )
    }

    this.loadPolygon = true;
  }

  delPolygon(){
    if (this.polygon) {
      this.polygon.setMap(null);
    }

    this.polygons = [];
  }

  polygonCreated($event) {

    if (this.polygon) {
      this.polygon.setMap(null);
    }
    this.polygon = $event;
    this.addPolygonChangeEvent(this.polygon);

    var area = google.maps.geometry.spherical.computeArea(this.polygon.getPath());

    this.form.get('area_size').setValue(area.toFixed(2));

    google.maps.event.addListener(this.polygon, 'coordinates_changed', function (index, obj) {
      console.log('coordinates_changed');
    });
  }

  addPolygonChangeEvent(polygon) {
    var me = polygon,
    isBeingDragged = false,
    triggerCoordinatesChanged = function () {
      google.maps.event.trigger(me, 'coordinates_changed');
    };

    google.maps.event.addListener(me, 'dragstart', function () {
      isBeingDragged = true;
    });

    google.maps.event.addListener(me, 'dragend', function () {
      triggerCoordinatesChanged();
      isBeingDragged = false;
    });

    var paths = me.getPaths();
    this.polygons = [];

    var numberOfPath = polygon.getPath().getLength();
  
    for (let i = 0; i < numberOfPath; i++) {

      var vertex = polygon.getPath().getAt(i);

      this.polygons.push(
        {
          "seq": i+1,
          "lat": vertex.lat(),
          "lon": vertex.lng()
        }
      );
    }

    this.reset();

    paths.forEach(function (path, i) {
      google.maps.event.addListener(path, "insert_at", function () {
        triggerCoordinatesChanged();
      });
      google.maps.event.addListener(path, "set_at", function () {
        if (!isBeingDragged) {
          triggerCoordinatesChanged();
        }
      });
      google.maps.event.addListener(path, "remove_at", function () {
        triggerCoordinatesChanged();
      });
    });
  };

  reset(){
    this.cd.detectChanges();
  }

  setColor(color: string){
    this.form.get('color').setValue(color);

    this.managerOptions.polygonOptions.fillColor = color;
    this.managerOptions.polygonOptions.strokeColor = color;
    if(this.polygon){
      this.polygon.setOptions({
        fillColor: color,
        strokeColor: color
      });
    }
  }

  next(index){
    this.submitted = true;

    if(index == 2){
      if(
        this.form.controls.color.invalid
      ){
        return;
      }
    }
    this.tab = index;
    this.submitted = false;
  }

  save(){
    this.submitted = true;
    if(
      this.form.invalid || 
      (!this.isVideo(this.form.value.video) && this.form.value.video) ||
      !this.image ||
      this.sizeFileOver ||
      this.typeFileOver
    ){
      return;
    }

    if(this.AllPlot.length >= 6){
      $(`${this.warningModal}`).modal("show");
      return;
    }

    let zone = {
      farm_id: this.id,
      org_id: sessionStorage.getItem('Org'),
      child_org_id: sessionStorage.getItem('ChildOrg'),
      name: this.name,
      desc: this.form.value.desc,
      ares: {
        size: this.form.value.area_size.toString(),
        unit: 'ตารางเมตร'
      },
      active: true,
      background_img: "",
      icon: "",
      color: this.form.value.color,
      coordinates: {
          center: {
              lat: this.lat,
              lon: this.lng,
              zoom_lv: this.zoom
          },
          map_polygon: this.polygons
      } 
    }

    let plot = new FormData();
    plot.append("org_id", sessionStorage.getItem('Org'));
    plot.append("child_org_id", sessionStorage.getItem('ChildOrg'));
    plot.append("name", this.form.value.name);
    plot.append("desc", this.form.value.desc);
    plot.append("type", this.form.value.type);
    plot.append("farm_id", this.id);
    plot.append("video", this.form.value.video);
    plot.append("start_date", this.dateFormat(this.form.value.start_date));
    plot.append("end_date", this.dateFormat(this.form.value.end_date));
    plot.append("coordinates", JSON.stringify(zone.coordinates));
    plot.append("status", "on_rest");
    plot.append("picture", this.selectFile);
    
    this.farmService.createZone(zone).subscribe(res=>{

      if(res.code == 200){
        this.zone_id = res.data.zone_id;
        plot.append("zone_id", this.zone_id);
        
        this.farmService.createNewPlot(plot).subscribe(async plot=>{
          if(plot.code == 200){
            this.plot_id = plot.data.plot_id;

            if(this.form.value.camera_flag){
              this.createRealTimeCamera(plot, zone, this.zone_id);
            }else{
              this.getPlotMenu();
            }
          }else{
            this.farmService.deleteZone(this.zone_id).subscribe(zone=>{
              if(plot.message == 'Data existed'){
                this.errorMessage = 'ชื่อแปลงของท่านมีอยู่แล้ว กรุณาลองใหม่อีกครั้ง';
      
                this.reset();
                $(`${this.errorModal}`).modal("show");
              }else{
                this.errorMessage = 'กรุณาลองใหม่อีกครั้ง';
      
                this.reset();
                $(`${this.errorModal}`).modal("show");
              }
            });
          }
        })
      }else{
        this.errorMessage = 'กรุณาลองใหม่อีกครั้ง';
        
        this.reset();
        $(`${this.errorModal}`).modal("show");
      }
    })
  }

  createRealTimeCamera(data, zone, zone_id){
    let camera = {
      plot_id: data.data.plot_id,
      camera_id: this.form.value.camera_id
    }
    this.farmService.createRealTimeCamera(camera).subscribe(camera=>{
      let plot = new FormData();
      plot.append("plot_id", data.data.plot_id);
      plot.append("org_id", sessionStorage.getItem('Org'));
      plot.append("child_org_id", sessionStorage.getItem('ChildOrg'));
      plot.append("name", this.form.value.name);
      plot.append("desc", this.form.value.desc);
      plot.append("type", this.form.value.type);
      plot.append("farm_id", this.id);
      plot.append("video", this.form.value.video);
      plot.append("start_date", this.dateFormat(this.form.value.start_date));
      plot.append("end_date", this.dateFormat(this.form.value.end_date));
      plot.append("zone_id", zone_id);
      plot.append("coordinates", JSON.stringify(zone.coordinates));
      plot.append("status", "on_rest");
      plot.append("camera_flag", this.form.value.camera_flag);
      plot.append("camera_object_id", camera.data._id);
      plot.append("active", JSON.stringify(true));
      this.farmService.updateNewPlot(plot).subscribe(async plot=>{
        if(plot.code == 200){
  
          this.getPlotMenu();
        }
      })
    })
  }

  async getPlotMenu(){
    this.reset();

    await this.phameeService.getPlotMenu(sessionStorage.getItem('ChildOrg'))
    .subscribe(response => {
      let arrMenu = [];
      if (response.code == 200) {
        arrMenu = response.data    
        sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));

        $(`${this.successModal}`).modal("show");
      }
    });
  }

  dateFormat(date) {
    var datenow = new Date(date);
    return moment.utc(datenow, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
  }

  addPlot(){
  }

  addCrop(){
    this.router.navigateByUrl("/create-crop?zoneId="+this.zone_id+"&plotId="+ this.plot_id + "&tab=1").then(res=>{
      window.location.reload();
    });
  }

  back(): void {
    this.router.navigateByUrl("/manage-farm");
  }

  isVideo(url: string): boolean {
    if(url){
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.3gp'];
      return videoExtensions.some(ext => url.endsWith(ext));
    }else{
      return  false;
    }
  }

  uploadImage(){
    document.getElementById("image_file").click();
  }

  onFileChange(file){
    this.selectFile = <File>file[0];

    var mimeType = this.selectFile.type;
    var size = this.selectFile.size;

    if(size >= 100000000){
      this.sizeFileOver = true;
    }else{
      this.sizeFileOver = false;
    }

    if(mimeType.includes("jpeg")){
      this.typeFileOver = false;
    }else{
      this.typeFileOver = true;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.selectFile); 
    reader.onload = (_event) => { 
      this.image = reader.result; 

      this.reset();
    }
  }

  deleteFile(){
    this.image = null;
  }
}